import {Scroll} from './Scroll.js';

let $html = null;
let $body = null;
let $window = null;

class Page
{
	constructor ()
	{
		console.log('Page');

		this.$header = (Page.getBody()).find('> header');
		this.$btnShowMenu = $('#btn_show_menu');
		this.$btnHideMenu = $('#btn_hide_menu');

		new Scroll();
		this.bindPageEvents();

		// fix IE
		if ( navigator.appName == 'Microsoft Internet Explorer'
			||  !!(navigator.userAgent.match(/Trident/)
				|| navigator.userAgent.match(/rv:11/))
			|| (typeof $.browser !== "undefined" && $.browser.msie == 1))
		{
			(Page.getHtml()).addClass('is-ie');
			$('#header_main_logo').attr('src', '/_/images/skylink_logo.png');
		}
	}

	bindPageEvents ()
	{
		console.log('Page.bindEvents()');
		this.$btnShowMenu.on('click', this.showMobileMenu.bind(this));
		this.$btnHideMenu.on('click', this.hideMobileMenu.bind(this));
	}

	showMobileMenu ()
	{
		console.log('Page.showMobileMenu()');
		this.$header.addClass('is-mobile-menu-visible');
	}

	hideMobileMenu ()
	{
		this.$header.removeClass('is-mobile-menu-visible');
	}

	static getHtml ()
	{
		if ( $html === null )
		{
			$html = $('html');
		}
		return $html;
	}

	static getBody ()
	{
		if ( $body === null )
		{
			$body = $('body');
		}
		return $body;
	}

	static getWindow ()
	{
		if ( $window === null )
		{
			$window = $(window);
		}
		return $window;
	}
}

export {Page};